__turbopack_context__.v({
  "content": "styles-module__64lWva__content",
  "dropdown": "styles-module__64lWva__dropdown",
  "itemDescription": "styles-module__64lWva__itemDescription",
  "leftBlock": "styles-module__64lWva__leftBlock",
  "open": "styles-module__64lWva__open",
  "plusIcon": "styles-module__64lWva__plusIcon",
  "rightBlock": "styles-module__64lWva__rightBlock",
  "rotated": "styles-module__64lWva__rotated",
  "serviceContent": "styles-module__64lWva__serviceContent",
  "serviceDescription": "styles-module__64lWva__serviceDescription",
  "serviceDuration": "styles-module__64lWva__serviceDuration",
  "serviceIcon": "styles-module__64lWva__serviceIcon",
  "serviceInfo": "styles-module__64lWva__serviceInfo",
  "serviceItem": "styles-module__64lWva__serviceItem",
  "serviceName": "styles-module__64lWva__serviceName",
  "servicePrice": "styles-module__64lWva__servicePrice",
  "serviceRow": "styles-module__64lWva__serviceRow",
  "serviceText": "styles-module__64lWva__serviceText",
  "serviceTotal": "styles-module__64lWva__serviceTotal",
  "servicesList": "styles-module__64lWva__servicesList",
  "servicesSection": "styles-module__64lWva__servicesSection",
  "smallPlusIcon": "styles-module__64lWva__smallPlusIcon",
  "subtitle": "styles-module__64lWva__subtitle",
  "title": "styles-module__64lWva__title",
  "totalDuration": "styles-module__64lWva__totalDuration",
  "totalPrice": "styles-module__64lWva__totalPrice",
  "xIcon": "styles-module__64lWva__xIcon",
});
